export default __webpack_public_path__ + "static/frame-download-app@2x-6bde2fceb4a8afb44381065170d4e9c2.jpg";